import { useGlobalStore, useUserStore } from '@shared/store';
import { commonApi } from '../../apis';

// 初始化账号权限
export const initAccountPermission = async () => {
  try {
    const { currentCorpId, agentId } = useGlobalStore().appData;
    const { identity } = useUserStore().userInfo;

    const { ret, retdata = {} } = await commonApi.getAccountPermission<any, any>({
      corpId: currentCorpId,
      agentId,
      identity,
    });

    // 请求成功并且无权限时，跳转无权限页面
    if (ret === 0 && !retdata.valid) {
      // 无权限时更新账号权限状态
      useGlobalStore().setHasAccountPermission(false);
      // setup() 之外无法使用 useRouter，因此采用原生跳转
      location.replace(
        `${
          import.meta.env.VITE_SITE_HOST || location.origin
        }/caizhi_webapp/noAccountPermission?currentCorpId=${currentCorpId}&agentId=${agentId}`
      );
    }
  } catch (error) {
    console.log('初始化账号权限错误：', error);
  }
};
